const l = (e) => ["small", "medium", "large"].every((a) => a in e && ["src", "name"].every((r) => r in e[a]));
export {
  l as default
};
